module.exports = __webpack_public_path__ + "static/perch1-3ba7130b6750900f4982141b57fd4c31.png";